import React from "react";

const Maximize = () => {
  return (
    <img
      className="imgChangePopupSize"
      alt="maximize"
      width="20px"
      src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAA3UlEQVR4nO2VMQrCMBSGP8+gm7ro4qIOgovgolfwBGLFS+g19Bo6lhIc3LyKuUKl8AYpSZPUgCI++Gnz+nhfXvLSwC9ZAqQOXYCuR/zGBLgCDw9AR+IVoA0xWr4ZAVlAxcqSyOb/A95bogHQKPmibfIIyIGpjAvQHNjVaVMTYCaAhSQ/yXhIoLkAS+Ao74eKPC2gWQdwl+feMdHiMJ7rAHLgBqxERUWEdNEWWBv84xdAWe0QQJX1gUlJvdAKYpmyARJb/8YCxCpNfRSgPW611CHrv8jnykw9FWMvv8SeEBSFXt1uKxEAAAAASUVORK5CYII="
    />
  );
};

export default Maximize;
